import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import breakpoints from '../../breakpoints';
import styles from '../../styles';

const Container = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${styles.spacing['spacing-md']};
  grid-gap: ${styles.spacing['spacing-md']};
  margin: ${styles.spacing['spacing-2xl']} auto;
  max-width: 37.5rem;

  list-style: none;
  padding-inline-start: 0;
  padding: 0;

  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: ${({ count }) =>
      count === 3 ? '1fr 1fr 1fr' : '1fr 1fr'};
  }

  @media (min-width: ${breakpoints.md}) {
    max-width: 100%;
  }

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: ${({ count }) =>
      count === 3 ? '1fr 1fr 1fr' : '1fr 1fr 1fr 1fr'};
    grid-gap: ${styles.spacing['spacing-1xl']};
  }
`;

const MediaGridItem = styled.li`
  text-align: center;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.linkHover};
    }
  }

  h2 {
    margin: 0.25em 0;
    font-size: clamp(0.8125rem, 4vw, 1.4375rem);
  }

  img {
    max-width: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    margin-bottom: 0.25em;
  }
`;

const renderMediaGridItem = item => (
  <Inner>
    {item?.media?.asset?.url && (
      <img
        src={item.media.asset.url}
        alt={item?.media?.alt || item?.heading || item?.text}
        width={381}
        height={381}
      />
    )}
    {item?.heading && <h2>{item.heading}</h2>}
    {item?.text && <p>{item.text}</p>}
  </Inner>
);

const Inner = styled.div`
  padding: revert;
`;

function MediaGrid({ value, getInternalLink }) {
  const { heading, items } = value;
  const count = items?.length || 0;

  return (
    <>
      {heading && <h2>{heading}</h2>}

      <Container count={count}>
        {items?.length > 0 &&
          items.map(item => (
            <MediaGridItem key={item?._key || item?.text || item?.heading}>
              {item?.link?.linkType === 'internal' && (
                <LocalizedLink
                  to={getInternalLink({
                    ...item.link,
                    reference: item.link?.internalLink,
                  })}
                >
                  {renderMediaGridItem(item)}
                </LocalizedLink>
              )}

              {item?.link?.linkType === 'external' && (
                <a
                  href={item?.link?.href}
                  target={item?.link?.blank ? '_blank' : '_self'}
                  rel="noreferrer"
                >
                  {renderMediaGridItem(item)}
                </a>
              )}

              {(!item?.link?.linkType || item?.link?.linkType === 'disable') &&
                renderMediaGridItem(item)}
            </MediaGridItem>
          ))}
      </Container>
    </>
  );
}

MediaGrid.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        media: PropTypes.shape({}),
        heading: PropTypes.string,
        text: PropTypes.string,
      })
    ),
  }).isRequired,
  getInternalLink: PropTypes.func.isRequired,
};

export default MediaGrid;
